import React from "react";
import { Box, Typography } from "@mui/material";
import { CheckValue } from "../../../Service/service";

const CampusTitle = (props) => {
  const { name = "", index = null, sx = {}, variant = "h5" } = props;
  return (
    <Typography
      variant={variant}
      sx={(theme) => ({ ...theme.mixins.overflow,maxWidth:'100%', ...sx })}
    >
      {CheckValue(index) ? (
        <Box component={"span"} sx={{ color: "#51555C" }}>
          {index}:
        </Box>
      ) : null}
      {name}
    </Typography>
  );
};

export default React.memo(CampusTitle);
